Shopify.customCart = Shopify.customCart || {};
Shopify.customCart.formatMoney = function(value) {
  return Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:2}).format(value);
}

// New function to check if discount was explicitly removed by user
function checkIfDiscountWasRemoved() {
  // Check both our flag and shipping app flag
  return localStorage.getItem('discount_explicitly_removed') === 'true' || 
         localStorage.getItem('discount_code_removed') === 'true';
}

// New function to mark discount as explicitly removed
function markDiscountAsRemoved() {
  localStorage.setItem('discount_explicitly_removed', 'true');
}

// New function to clear the removed flag when new discount is applied
function clearDiscountRemovedFlag() {
  localStorage.removeItem('discount_explicitly_removed');
  localStorage.removeItem('discount_code_removed');
  localStorage.removeItem('discount_code_removed_timestamp');
}

// Function to check and handle shipping app discount removal
async function checkShippingAppDiscountRemoval() {
  // Only process if shipping app flag exists and we haven't already processed it
  if (localStorage.getItem('discount_code_removed') === 'true' && 
      localStorage.getItem('discount_explicitly_removed') !== 'true') {
    // Mark discount as removed using our flag too
    markDiscountAsRemoved();
    
    // Restore prices immediately
    restoreCartDrawerPricesImmediately();
    
    // Remove discount code from cart attributes
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {'discount_code': null, 'coupon_code': null}})
    });
    
    // Call discount removal API
    await fetch(window.Shopify.routes.root + `discount/0`, {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    });
    
    // Verify prices
    await restoreCartDrawerPricesAfterDiscountRemoval();
    
    // Update cart drawer
    const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;
    if(open_to_all_users == 'true'){
      await updateCartDrawer();
    } else {
      await errorUpdateCartDrawer();
    }
  }
}

// Function to restore original prices IMMEDIATELY from DOM (synchronous, no delay)
function restoreCartDrawerPricesImmediately() {
  try {
    // Restore subtotal immediately - use old-price span if it exists (original price)
    document.querySelectorAll('.totals__subtotal-value').forEach((el) => {
      const oldPriceSpan = el.querySelector('.old-price');
      const dataCartSubtotal = el.querySelector('[data-cart-subtotal]');
      
      if (oldPriceSpan && oldPriceSpan.innerText.trim()) {
        // Use the old-price (original price) as the new price
        const originalPrice = oldPriceSpan.innerText.trim();
        const dataValue = dataCartSubtotal?.getAttribute('data-cart-subtotal') || '';
        el.innerHTML = `<span data-cart-subtotal="${dataValue}">${originalPrice}</span>`;
      } else if (dataCartSubtotal) {
        // If no old-price, use the data-cart-subtotal value to calculate original
        const subtotalValue = parseInt(dataCartSubtotal.getAttribute('data-cart-subtotal')) || 0;
        if (subtotalValue > 0) {
          const originalPrice = Shopify.customCart.formatMoney(subtotalValue / 100);
          el.innerHTML = `<span data-cart-subtotal="${subtotalValue}">${originalPrice}</span>`;
        }
      }
    });
    
    // Hide discount tag and amount, show discount form
    document.querySelectorAll('.cart__discount-tag').forEach((el) => el.classList.remove('show'));
    document.querySelectorAll('.cart__discount-amount').forEach((el) => el.classList.remove('show'));
    document.querySelectorAll('.cart__discount-form').forEach((el) => el.classList.add('show'));
    
    // Clear discount input
    document.querySelectorAll('#ajax-cart-discount-input').forEach((el) => {
      if (el) el.value = '';
    });
    
    // Clear discount error messages
    clearCouponMessage();
    
  } catch (error) {
    console.error('Error restoring cart drawer prices immediately:', error);
  }
}

// Function to restore original prices in cart drawer when discount is removed (async verification)
async function restoreCartDrawerPricesAfterDiscountRemoval() {
  try {
    // Wait a bit to ensure cart is fully updated on Shopify side
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Fetch fresh cart data to get original prices
    const response = await fetch('/cart.js');
    const cartData = await response.json();
    
    if (!cartData || !cartData.items) {
      return;
    }
    
    // Calculate original subtotal from items
    let originalSubtotal = 0;
    cartData.items.forEach(item => {
      const linePrice = item.original_line_price || item.line_price;
      originalSubtotal += linePrice;
    });
    
    // Use original_total_price if available (more accurate)
    if (cartData.original_total_price !== undefined && cartData.original_total_price > 0) {
      originalSubtotal = cartData.original_total_price;
    }
    
    const subtotalFormatted = Shopify.customCart.formatMoney(originalSubtotal / 100);
    
    // Update subtotal in cart drawer - remove old-price span if it exists
    document.querySelectorAll('.totals__subtotal-value').forEach((el) => {
      el.innerHTML = `<span data-cart-subtotal="${originalSubtotal}">${subtotalFormatted}</span>`;
    });
    
  } catch (error) {
    console.error('Error restoring cart drawer prices:', error);
  }
}

function openCartDrawer() {
  setTimeout(function(){
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
    document.querySelector("html").classList.add("cart-drawer--active");
    document.querySelector("body").classList.add("cart-drawer--active");
    if(document.querySelector(".rebuy-cart")){
      document.querySelector(".rebuy-cart").remove();
    }
  },400)
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");

  document.querySelector("html").classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    if(count == '0'){
      document.querySelector(".cart-count-bubble").classList.add("hidden");
    }else{
      document.querySelector(".cart-count-bubble").classList.remove("hidden");
    }
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  
  // Check for shipping app discount removal
  await checkShippingAppDiscountRemoval();
  
  // Check if discount was removed - if so, restore prices and don't auto-apply
  if (checkIfDiscountWasRemoved()) {
    // Restore original prices IMMEDIATELY from DOM (synchronous, no delay)
    restoreCartDrawerPricesImmediately();
    // Then do async verification to ensure accuracy
    await restoreCartDrawerPricesAfterDiscountRemoval();
    // Don't call tieredDiscount() if discount was explicitly removed
  } else {
    tieredDiscount();
  }
  
  addDiscountCodeListeners();
  updateCartDiscounts();
}

async function errorUpdateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  
  // Check for shipping app discount removal
  await checkShippingAppDiscountRemoval();
  
  // Check if discount was removed - if so, restore prices and don't auto-apply
  if (checkIfDiscountWasRemoved()) {
    // Restore original prices IMMEDIATELY from DOM (synchronous, no delay)
    restoreCartDrawerPricesImmediately();
    // Then do async verification to ensure accuracy
    await restoreCartDrawerPricesAfterDiscountRemoval();
    // Don't call errorTieredDiscount() if discount was explicitly removed
  } else {
    errorTieredDiscount();
  }
  
  addDiscountCodeListeners();
  updateCartDiscounts();
}

function addCartDrawerListeners() {

  // Remove handling Shipping and Tax products here
  const handling = document.querySelector(".handling-product")?.innerHTML;
  if(handling == 'true'){
    const cartdata = fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [43033812107448] : 0, [43032880480440] : 0, [43033812762808] : 0 } }),
    });
    location.reload();
  }
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        button.classList.add("loader-icon");
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement;

        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity : currentQuantity;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();

      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // remove icon update
  if(document.querySelector(".cart-remove-button")){
    document
      .querySelectorAll(".cart-remove-button")
      .forEach((remove_button) => {
      remove_button.addEventListener("click", async (e) => {
      e.preventDefault();
      const remove_key = remove_button.getAttribute("data-product-key");

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [remove_key]: 0 } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
    });
  });
  }

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {

        closeCartDrawer();
      });
    });

}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
       // Skip if form is inside product-form custom element (handled by product-form.js) added for doublingissue
    // But still open drawer after product-form completes
    const isProductForm = form.closest('product-form');
    if (isProductForm) {
      e.preventDefault();
      e.stopPropagation();
      // Wait for product-form to complete, then open drawer
      setTimeout(async () => {
        // Get cart count
        const res = await fetch("/cart.js");
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        // Update cart drawer
        await updateCartDrawer();
        // Open cart drawer
        openCartDrawer();
      }, 500);
      return;
    }
    e.preventDefault();

    // different recipients logic
    const qty = document.querySelector('input[name="quantity"]')?.value;
    const checkboxcheck = document.querySelector('#splitQtyCheck')?.checked;
    const customiseProduct = document.querySelector('.cpb-radio-button-text')?.innerHTML;
    if(customiseProduct == undefined){
    if (qty > 1 && checkboxcheck) {
      const id = document.querySelector('input[name="id"]')?.value;
      const _image = document.querySelector('input[name="properties[_image]"]')?.value;
      const Message = document.querySelector('textarea[name="properties[Message]"]')?.value;``
      const To = document.querySelector('input[name="properties[To]"]')?.value;
      const From = document.querySelector('input[name="properties[From]"]')?.value;
      var cartItem = {
        'items': []
      };
      for (var i = 0; i < qty; i++) {
        var currentItem = {
          'id': id,
          'quantity': 1,
          'properties': {
            'Message': Message,
            'To': To,
            'From': From,
            '_image': _image,
            '_rand': Math.floor(
              (Math.random() * 10000) + 1
            )
          }
        }
        cartItem["items"].push(currentItem);
      }
      // Submit form with ajax for different line item
      await fetch("/cart/add", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartItem)
      });
    }else{
      const id = document.querySelector('input[name="id"]')?.value;
      const _image = document.querySelector('input[name="properties[_image]"]')?.value;
      const Message = document.querySelector('textarea[name="properties[Message]"]')?.value;``
      const To = document.querySelector('input[name="properties[To]"]')?.value;
      const From = document.querySelector('input[name="properties[From]"]')?.value;
      var cartItem = {
        'items': []
      };
      var currentItem = {
          'id': id,
          'quantity': qty,
          'properties': {
            'Message': Message,
            'To': To,
            'From': From,
            '_image': _image
          }
        }
      cartItem["items"].push(currentItem);

      //Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartItem)
      });
    }
  }

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  if (a.closest('#ajax-cart')) return; // Don't override the cart drawer cart link
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

function tieredDiscount() {
  // Check if discount was explicitly removed - if so, don't auto-apply
  if (checkIfDiscountWasRemoved()) {
    // Hide discount tag and amount, show discount form
    document.querySelectorAll('.cart__discount-tag').forEach((el) => el.classList.remove('show'));
    document.querySelectorAll('.cart__discount-amount').forEach((el) => el.classList.remove('show'));
    document.querySelectorAll('.cart__discount-form').forEach((el) => el.classList.add('show'));
    // Clear discount input
    document.querySelectorAll('#ajax-cart-discount-input').forEach((el) => {
      if (el) el.value = '';
    });
    return;
  }
  
  var baseTieredAmount = Shopify.tieredDiscount.baseTieredAmount*100;
  var cartTotalPrice = document.querySelector('.cart-total-price')?.innerHTML;
  const currentURL = window.location.search;
  const urlParams = new URLSearchParams(currentURL);
  const discount = urlParams.get('coupon');
  const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;
  const coupon_code = document.querySelector('.tiered-discount-code')?.innerHTML;
  const tiered_coupon_code = document.querySelector('.tiered-coupon-code')?.innerHTML;
  const applied_coupon_code = document.querySelector('.cart__discount-tag-text')?.innerHTML;

  if(open_to_all_users == 'true'){
    document.querySelector("#ajax-cart-discount-input").value = coupon_code;
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':coupon_code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          return calculateCartDiscounts(data, coupon_code);
        });
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }

  if(urlParams.has('coupon')){
    if(baseTieredAmount <= cartTotalPrice){
      document.querySelector("#ajax-cart-discount-input").value = discount;
      document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
      openCartDrawer();
    }else{
      if(document.querySelector("#ajax-cart-discount-input")?.value != undefined){
        document.querySelector("#ajax-cart-discount-input").value = '';
      }
     //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
    }
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'coupon_code':discount,'discount_code':discount}})})
        .then((response) => {
          return response.json();
      })
  }

  if(tiered_coupon_code != ''){
    if(tiered_coupon_code != undefined){
      document.querySelector("#ajax-cart-discount-input").value = tiered_coupon_code;
    }
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':tiered_coupon_code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          if(tiered_coupon_code != undefined){
            //return calculateCartDiscounts(data, tiered_coupon_code);
          }
        });
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }

  if(applied_coupon_code != ''){
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
  }
}

function errorTieredDiscount() {
  const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;

  if(open_to_all_users == 'true'){
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }


}

function addDiscountCodeListeners() {

  // Add discount code
  document.querySelectorAll('.cart__discount-apply-button').forEach((el) => {
    el.addEventListener("click", async (e) => {
      e.preventDefault();
      
      // Clear the removed flag when user manually applies a new discount
      clearDiscountRemovedFlag();
      
      let code = el.closest('form').querySelector('.cart__discount-input')?.value || 
                 el.closest('form').querySelector('#ajax-cart-discount-input')?.value;
      if (!code) {
        setCouponMessage("Please specify a coupon code");
        return;
      }
      // Add/update the discount code in cart attributes
      fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':code,'coupon_code':code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          return calculateCartDiscounts(data, code);
        });
    });
  });

  // Remove discount code
  document.querySelectorAll('.cart__discount-tag-remove').forEach((el) => {
    el.addEventListener("click", async (e) => {
      e.preventDefault();
      
      // Mark discount as explicitly removed so it doesn't re-apply
      markDiscountAsRemoved();
      
      // Restore original prices IMMEDIATELY from DOM (synchronous, no delay)
      restoreCartDrawerPricesImmediately();
      
      await fetch(window.Shopify.routes.root + `discount/0`,{method: 'GET',headers: {'Content-Type':'application/json'}});
      // Remove the discount code from cart attributes
      await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':null,'coupon_code':null}})});
      
      // Then do async verification to ensure accuracy
      await restoreCartDrawerPricesAfterDiscountRemoval();
      
      // Update the cart drawer without the metafield
      const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;
      if(open_to_all_users == 'true'){
        await updateCartDrawer();
      }else{
        await errorUpdateCartDrawer();
      }
    });
  });
}
tieredDiscount();
addDiscountCodeListeners();

async function updateCartDiscounts() {
  // Check if discount was explicitly removed - if so, restore original prices and don't re-apply
  if (checkIfDiscountWasRemoved()) {
    // Restore original prices IMMEDIATELY from DOM (synchronous, no delay)
    restoreCartDrawerPricesImmediately();
    // Then do async verification to ensure accuracy
    await restoreCartDrawerPricesAfterDiscountRemoval();
    return;
  }
  
  const code = document.querySelector('#ajax-cart-discount-input')?.value || document.querySelector('.cart__discount-input')?.value;
  if (code) {
    let response = await fetch('/cart.js');
    let data = await response.json();
    await calculateCartDiscounts(data, code);
  } else {
    // Reset discounts
  }
}

async function calculateCartDiscounts(data, code) {
  disableDiscountFields();
  if (data.items) {
    const payload = {
      cart: data,
      code: code
    };
    const response = await fetch("/a/shipping/coupon", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      referrerPolicy: "no-referrer",
      body: JSON.stringify(payload)
    });
    const responseData = await response.json();
    let isValid = false;
    let isFreeShippingValid = false;
    if (typeof responseData.discountCodes === "undefined") {
      await updateCartDrawer();
      setCouponMessage("An error occurred applying the coupon code");
    } else {
      responseData.discountCodes.forEach((discountCode) => {
        if (discountCode.code == code) {
          isValid = discountCode.applicable;
        }
      });
      let cart_items = responseData.items;
      let cart_discount_total = 0;
      let cartTotalPrice = parseInt(document.querySelector('.cart-total-price')?.innerHTML);
      let i;
      for(i = 0; i < cart_items.length; i++){
        if( cart_items[i].subtotal > cart_items[i].total){
          cart_discount_total += cart_items[i].subtotal;
        }
      }
      cart_discount_total = cart_discount_total.toFixed(2)*100;
      if (responseData.freeShippingData && responseData.freeShippingData.codeApplies) {
        if (responseData.total > responseData.freeShippingData.minimumRequirement) {
          isFreeShippingValid = true;
          //TODO: Set free shipping applied message
        }
      }
      if (!isValid && !isFreeShippingValid) {
        // Mark discount as explicitly removed since it's invalid
        markDiscountAsRemoved();
        
        // Restore original prices IMMEDIATELY from DOM (synchronous, no delay)
        restoreCartDrawerPricesImmediately();
        
        await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':null,'discounted_cart_total':null}})});
        await errorUpdateCartDrawer();
        const theme_coupon_code = document.querySelector('.tiered-discount-code')?.innerHTML;
        document.querySelector("#progress")?.classList.add("zero-width");
        
        // Then do async verification to ensure accuracy
        await restoreCartDrawerPricesAfterDiscountRemoval();
        
        if(theme_coupon_code !=  code){
          setCouponMessage("Please note: discount codes cannot be applied to items on sale.");
        }
      } else {
        // Clear the removed flag since discount is being successfully applied
        clearDiscountRemovedFlag();
        document.querySelector("#progress")?.classList.remove("zero-width");
        if (responseData.lineDiscount > 0) {
          //TODO: Apply line discounts
        } else {
          document.querySelectorAll('#ajax-cart .cart-item').forEach((row) => row.dataset.discount = 0);
          //TODO: reset cart page discounts
        }

        if(cart_discount_total > 0 && cartTotalPrice >= cart_discount_total){
          await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discounted_cart_total':cart_discount_total}})});
           const res = await fetch("/?section_id=cart-drawer");
           const text = await res.text();
           const html = document.createElement("div");
           html.innerHTML = text;

          const newBox = html.querySelector(".cart-drawer").innerHTML;
          document.querySelector(".cart-drawer").innerHTML = newBox;

          addCartDrawerListeners();
          tieredDiscount();
          addDiscountCodeListeners();
        }
        document.querySelectorAll('.cart__discount-amount').forEach((el) => {
          el.dataset.totalDiscount = Math.round(responseData.totalDiscount*100);
          el.querySelector('.amount').innerHTML = "- " + Shopify.customCart.formatMoney(responseData.totalDiscount);
        });
        document.querySelectorAll('.totals__subtotal-value').forEach((el) => {

          const newFormattedDiscount = Shopify.customCart.formatMoney(responseData.totalDiscount);
          const newFormattedTotal = Shopify.customCart.formatMoney(responseData.total);
          const newFormattedCompare = Shopify.customCart.formatMoney(responseData.subtotal);
          el.innerHTML = `<span data-cart-subtotal="`+(responseData.subtotal*100)+`">`+newFormattedTotal+`</span> <span class="old-price">`+newFormattedCompare+`</span>`;
        })
        document.querySelectorAll('.cart__discount-form').forEach((el) => el.classList.remove('show'));
        document.querySelectorAll('.cart__discount-tag').forEach((el) => el.classList.add('show'));
        document.querySelectorAll('.cart__discount-amount').forEach((el) => el.classList.add('show'));
        document.querySelectorAll('.cart__discount-tag-text').forEach((el) => el.innerText = code);
        clearCouponMessage();
      }
    }
  }
  enableDiscountFields();
}

async function disableDiscountFields() {
  document.querySelectorAll('.cart__discount-apply-button,.cart__discount-input').forEach((el) => el.disabled = true);
}
async function enableDiscountFields() {
  document.querySelectorAll('.cart__discount-apply-button,.cart__discount-input').forEach((el) => el.disabled = false);
}
function setCouponMessage(message) {
  document.querySelectorAll('.cart__discount-error').forEach((el) => {
    el.innerHTML = message;
    el.classList.add('show');
  })
  //return false;
}
function clearCouponMessage() {
  document.querySelectorAll('.cart__discount-error').forEach((el) => {
    el.innerHTML = '';
    el.classList.remove('show');
  })
}

// Check immediately on page load if discount was removed and restore prices in cart drawer
// This runs before updateCartDiscounts to prevent showing discounted prices
(function restoreCartDrawerPricesOnPageLoad() {
  // Check for shipping app discount removal on page load
  checkShippingAppDiscountRemoval();
  
  if (checkIfDiscountWasRemoved()) {
    // Function to restore prices and show discount form
    function doRestore() {
      // Use the immediate restore function which handles everything
      restoreCartDrawerPricesImmediately();
    }
    
    // Run immediately if DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', doRestore);
    } else {
      doRestore();
    }
    
    // Also run after a short delay to catch any delayed rendering
    setTimeout(doRestore, 0);
    setTimeout(doRestore, 100);
    
    // Use requestAnimationFrame to run after first paint
    requestAnimationFrame(function() {
      requestAnimationFrame(doRestore);
    });
  }
})();

updateCartDiscounts();

// Periodic check for shipping app discount removal (runs every 1 second)
// This ensures we catch discount removals from shipping app
setInterval(() => {
  checkShippingAppDiscountRemoval();
}, 1000);
